import { PluginContextValues } from '../types';

export const PLUGIN_REQUEST_ORIGIN = {
  header: 'x-plugin-request-origin',
  values: {
    admin: 'admin' satisfies PluginContextValues,
    user: 'frontoffice' satisfies PluginContextValues,
  },
};
